import React, { useContext, useEffect, useState } from "react";
import { Link, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Box, Button, IconButton, CircularProgress } from '@mui/material'
import { Close, Upload } from '@mui/icons-material';
import AppContext from "../../utils/app-context.js";
import { nanoid } from "nanoid";
import toast from "react-hot-toast";
import Loading from "../loading.js";


export default function StoryAudio(props) {
    const { state, dispatch } = useContext(AppContext);
    const user = state.userData
    const {showAudio, toggleShowAudio} = props;
    const [loginOpen, setLoginOpen] = useState(false)
    const [mediaOption, setMediaOption] = useState("Selected Media");
    const [isUploading, setIsUploading] = useState(false);
    const [isRemoving, setIsRemoving] = useState(false);
    const activeStory = state.stories.activeStory;

    const handleMediaChange = (event) => {
      setMediaOption(event.target.value);
    };

    const handleAudioUpload = async(event) => {
      if(isUploading) return;
      if(!event.target.files || event.target.files.length === 0) return;
      const file = event.target.files[0];
      event.target.files = null;
      setIsUploading(true);
     try{
      const result = await dispatch({type: "UPLOAD_AUDIO", payload: {file}});
      /*setActiveStory({...activeStory, last_audio: URL.createObjectURL(file),audio_file_name: file.name}).then(() => {
        toast.success('Audio upload completed.');
        setLoading(false);
      });*/
      console.dir("result", result);
  
      } catch(err) {
        console.log("error uploading audio", err);
        setIsUploading(false);
        toast.error('Audio upload failed.');
      }
    };
    
    const handleRemoveAudio =async () => {
      if(isRemoving) return;
      setIsRemoving(true);
       try{
        await dispatch({type: "REMOVE_AUDIO", payload: { }});
        //setActiveStory({...activeStory, last_audio: null,audio_file_name: null})
      } catch(err){
        setIsRemoving(false);
      }
    }

    useEffect(() => {
      if(state.stories.activeStory.audio && Object.keys(state.stories.activeStory.audio).length > 0) {
        setIsUploading(false);
      } 
      if(state.stories.activeStory.audio && Object.keys(state.stories.activeStory.audio).length === 0) {
        console.log('no audio');
        setIsUploading(false);
        setIsRemoving(false);
      }
    }, [state.stories.activeStory.audio]);


    useEffect(() => {
      if(state.app.forkingStory && state.stories.activeStory && state.stories.activeStory.portal_id && loc.pathname.indexOf(state.stories.activeStory.portal_id) == -1) {
        toast.success(
          Messages.success.projectForkedSuccessFully,
        );
        navigate('/p/'+state.stories.activeStory.portal_id)
        
        dispatch({ type:"CLEAR_FORK", payload:{} })
      }
    }, [state.app.forkingStory, state.stories.activeStory])

    const audioDialog =  <Dialog
      open={showAudio}
      onClose={() => toggleShowAudio()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">Story Audio</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box sx={{marginBottom:'25px'}}>Update the audio for this story.</Box>
            {isUploading || isRemoving ? (
              <Loading />
            ) : (activeStory.audio && Object.keys(activeStory.audio).length > 0) ? (
              <>
                <Link href={activeStory.audio}  sx={{ }}  target="_blank" rel="noopener noreferrer">
                {activeStory.audio.file_name}
                </Link>
                <IconButton onClick={handleRemoveAudio} sx={{ }}  aria-label="Remove audio">
                  <Close />
                </IconButton>
              </>
            ) : (
              <>
          
                <Link component="label" aria-label="Upload audio" sx={{ display:"flex", alignContent:"center", textDecoration:"none", "&:hover": {cursor: "pointer", textDecoration:"underline"} }}>
                  <Upload sx={{ marginRight:"10px" }} /> Upload new audio file
                  <input
                    type="file"
                    accept="audio/*"
                    hidden
                    onChange={handleAudioUpload}
                    onCancel={() => {console.log("cancelled")}}
                  />
                </Link>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => toggleShowAudio()} color="primary">
            Close
          </Button>
        </DialogActions>

      </Dialog>

    return (
      <>
        {audioDialog}
      </>
    );
} 